﻿/**
 * Announcement bar — promo dismiss + height sync.
 */
(function () {
  function setAnnouncementBarHeight() {
    var section = document.querySelector('.shopify-section--announcement-bar:not([hidden])');
    if (section) {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        section.offsetHeight.toFixed(2) + 'px'
      );
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
  }

  function initAnnouncementDismiss() {
    document.querySelectorAll('[data-announcement-dismiss="promo"]').forEach(function (btn) {
      var promo = btn.closest('.announcement-bar--promo');
      if (!promo) return;

      var section = btn.closest('.shopify-section--announcement-bar');
      var sectionId = section ? section.id.replace(/^shopify-section-/, '') : 'default';
      var key = 'announcement-promo-dismissed-' + sectionId;

      if (sessionStorage.getItem(key)) {
        promo.hidden = true;
        setAnnouncementBarHeight();
        return;
      }

      btn.addEventListener('click', function () {
        sessionStorage.setItem(key, '1');
        promo.hidden = true;
        setAnnouncementBarHeight();
      });
    });
  }

  function init() {
    initAnnouncementDismiss();
    setAnnouncementBarHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
